import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const METLIMSAccountRequest = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">METLIMS Account Request Form</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) provides the METLIMS portal to facilitate laboratory management, test requests, and result tracking.
          </p>
          <p className="subtitle">
            The METLIMS Account Request Form enables organizations and stakeholders to request access to the portal for seamless interaction with MBS laboratories.
          </p>
        </div>
      </section>

      {/* === Account Request Information Section === */}
      <section className="intro-section">
        <h2 className="section-title">Requesting a METLIMS Account</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Fill out the official METLIMS Account Request Form accurately.</li>
              <li>Provide organization details and authorized contact information.</li>
              <li>Specify the intended use of the METLIMS portal (e.g., test requests, tracking results).</li>
              <li>Submit any required supporting documents for verification.</li>
              <li>Agree to the terms and conditions for using the METLIMS portal.</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Account requests are reviewed and approved by MBS administration.</li>
              <li>Once approved, users will receive login credentials and instructions.</li>
              <li>Training and guidance are provided to new METLIMS users.</li>
              <li>Accounts are regularly monitored for compliance and proper use.</li>
              <li>Support is available for technical or operational issues with the portal.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for METLIMS Account Requests</h2>
        <p>
          For assistance with the METLIMS Account Request Form or portal access, please contact the MBS METLIMS Support Team.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:metlims@mbs.mw">metlims@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 999</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          The METLIMS portal ensures efficient laboratory interactions, tracking of test requests, and access to test results for authorized users.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default METLIMSAccountRequest;
